function LetsGo() {
    return ( 
        <>
            <section className="getting-started">
                <div className="container">
                    <div className="heading">Let's Start Your Onlyfans career!</div>
                    <div className="description">
                    Fill out the form and take the first step toward becoming a model. Your journey to success starts here!
                    </div>
                </div>

                <div className="elements element-1">❤️</div>
                <div className="elements element-2">🐰</div>
                <div className="elements element-3">👛</div>
                <div className="elements element-4">💸</div>
                <div className="elements element-5">🏎️</div>
            </section>
        </>
     );
}

export default LetsGo;